import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Dropdown, DropdownContent, useDropdown } from 'ziphy-web-shared/basic/lib/functional';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import { getTelehealthAppointmentId } from '@nedoShared/modules/dashboard/dashboard.helper';
import { useOrderItemDropdown } from '../../hooks/useOrderItemDropdown';
import styles from './OrderItemActionsDropdown.module.scss';
export const OrderItemActionsDropdown = ({ order }) => {
    const { t } = useTranslation();
    const { handleChangeConsultationDate, handleCopyOrderId, handleCancelOrder } = useOrderItemDropdown({ order });
    const telehealthId = useMemo(() => getTelehealthAppointmentId(order.attachments), [order]);
    const handleGoToConsultation = () => {
        if (!telehealthId)
            return;
        $router.history.push(`/appointments/${telehealthId}`);
    };
    const scheduleTelehealth = () => {
        if (!telehealthId)
            return;
        $router.history.push(`/explore/consultation/${order._id}`);
    };
    const items = useMemo(() => [
        // {
        //   id: 'change-consultation-date',
        //   label: t('label.change_consultation_date'),
        //   onClick: handleChangeConsultationDate,
        // },
        ...(order.status === 'created'
            ? [
                {
                    id: 'schedule-telehealth-visit',
                    label: t('label.schedule_telehealth_visit'),
                    onClick: scheduleTelehealth,
                },
            ]
            : []),
        ...(telehealthId
            ? [
                {
                    id: 'go-to-consultation',
                    label: t('btn.to_telehealth'),
                    onClick: handleGoToConsultation,
                },
            ]
            : []),
        { id: 'copy-order-id', label: t('label.copy_order_id'), onClick: handleCopyOrderId },
        // {
        //   id: 'cancel-order',
        //   label: <span className={styles.cancelOrder}>{t('label.cancel_order')}</span>,
        //   onClick: handleCancelOrder,
        // },
    ], [handleChangeConsultationDate, handleCopyOrderId, handleCancelOrder]);
    const { filteredItems } = useDropdown(items);
    return (_jsx(Dropdown, Object.assign({ renderButton: ({ fieldRef, onToggle }) => (_jsx(Button, { ref: fieldRef, className: styles.moreBtn, mode: ['justIcon', 'secondary-dark', 'sm'], leftElement: "moreDots", onClick: onToggle })), direction: ['bottom'], maxWidth: 420 }, { children: _jsx(DropdownContent, { items: filteredItems }) })));
};
